import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Paper, Typography, Box, Button, CircularProgress } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

const StripeOnboardingRefreshPage: React.FC = () => {
  const navigate = useNavigate();

  // Auto-redirect to profile after a brief moment
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/profile');
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <CircularProgress />
          <Typography variant="body1" color="text.secondary">
            Redirecting to your profile...
          </Typography>
          <Button
            variant="outlined"
            startIcon={<ArrowBack />}
            onClick={() => navigate('/profile')}
          >
            Go to Profile Now
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default StripeOnboardingRefreshPage;
